<template>
  <div class="knowledge-list-body">
    <div class="knowledge-list-head">
      <vue-particles
        color="#b1b1b1"
        :particleOpacity="0.7"
        :particlesNumber="100"
        shapeType="circle"
        :particleSize="4"
        linesColor="#bbb"
        :linesWidth="2"
        :lineLinked="true"
        :lineOpacity="0.4"
        :linesDistance="150"
        :moveSpeed="3"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push"
        class="cash"
      >
      </vue-particles>
      <div class="knowledge-list-head-search">
        <a-input-search
          style="width: 680px"
          placeholder="找场景、方案、案例、供应商"
          enter-button="搜索一下"
          size="large"
          v-model="listSearchVal"
          @search="searchBtn"
        />
      </div>
    </div>
    <div class="knowledge-list-tab">
      <div>
        <span :class="{ active: searchType === '1' }" @click="searchType = '1'"
          >场景</span
        >
        <span :class="{ active: searchType === '2' }" @click="searchType = '2'"
          >案例</span
        >
      </div>
    </div>
    <div class="knowledge-content-body">
      <div class="knowledge-list-body">
        <div v-if="searchType === '1'">
          <scenes-list :search="searchVal" />
        </div>
        <div v-if="searchType === '2'">
          <case-list :search="searchVal" />
        </div>
      </div>
      <div class="knowledge-list-side">
        <div>
          <p>热搜词云</p>
          <div class="knowledge-side-lable">
            <wordcloud
              :data="wordCloudList"
              nameKey="text"
              valueKey="count"
              :color="myColors"
              :showTooltip="false"
              :fontSize="[16, 30]"
              spiral="rectangular"
              font="Arial"
              fontScale="n"
              :wordPadding="10"
              :rotate="tagRotate"
              :wordClick="wordClickHandler"
            >
            </wordcloud>
          </div>
        </div>
        <!--        <div>-->
        <!--          <p>案例指数</p>-->
        <!--          <div>-->
        <!--            <div id="echarts" style="width: 100%; height: 216px"></div>-->
        <!--          </div>-->
        <!--        </div>-->
        <div>
          <p>搜索历史</p>
          <div class="search-history-body">
            <div v-for="(el, index) in searchList" :key="index">
              <p>{{ el.keywords }}</p>
              <span>{{ el.searchTime | lastTime }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import scenesList from "./scenesList.vue";
import caseList from "./caseList.vue";
import wordcloud from "vue-wordcloud";
import { getSearchList, getWordClouds } from "@/api/zsy";
export default {
  components: {
    scenesList,
    caseList,
    wordcloud,
  },
  data() {
    return {
      searchVal: "",
      listSearchVal: "",
      searchType: "1",
      tagRotate: { from: 0, to: 0, numOfOrientation: 0 },
      myColors: ["#5B8FF9", "#78D3F8", "#7262FD", "#F6BD16", "#61DDAA"],
      wordCloudList: [],
      searchList: [],
    };
  },
  mounted() {
    this.searchVal = this.$route.query.search;
    this.listSearchVal = this.$route.query.search;
    // this.myEcharts();
    this.loadWordClouds();
    this.loadSearchHistory();
  },
  methods: {
    loadWordClouds() {
      getWordClouds(this.searchType).then((res) => {
        this.wordCloudList = res.data;
      });
    },
    loadSearchHistory() {
      getSearchList({ current: 1, size: 10 }).then((res) => {
        this.searchList = res.data.records;
      });
    },
    searchBtn() {
      this.searchVal = this.listSearchVal;
    },
    wordClickHandler(name, value, vm) {
      console.log("wordClickHandler", name, value, vm);
    },
    myEcharts() {
      var myChart = this.$echarts.init(document.getElementById("echarts"));
      var option = {
        tooltip: {
          trigger: "axis",
        },
        color: ["#1ABC9C", "#FFA842"],

        grid: {
          top: 20,
          left: 40,
          right: 30,
          bottom: 40,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: ["03月", "04月", "05月", "06月", "07月", "08月"],
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                type: "solid",
                color: "#bbb",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            symbol: "none",
            name: "案例指数",
            type: "line",
            // smooth: true,
            data: [120, 132, 101, 134, 90, 230],
          },
        ],
      };
      myChart.setOption(option);
    },
  },
};
</script>

<style lang="less" scoped>
.knowledge-list-body {
  .knowledge-list-head {
    position: relative;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    .cash {
      position: absolute;
      width: 100%;
      left: 0;
      top: 0;
      bottom: 0;
      background: #0a1992;
    }
  }
  .knowledge-list-tab {
    background: #fff;
    > div {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      > span {
        height: 56px;
        border-bottom: 2px solid transparent;
        margin-right: 40px;
        cursor: pointer;
        transition: all 0.3s;
        line-height: 56px;
        &.active {
          border-color: #1abc9c;
        }
      }
    }
  }
  .knowledge-content-body {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    padding: 24px 0 40px;
    .knowledge-list-body {
      flex: 1;
    }
    .knowledge-list-side {
      width: 280px;
      margin-left: 24px;
      padding-top: 36px;
      > div {
        background: #fff;
        margin-bottom: 24px;
        > p {
          height: 48px;
          border-bottom: 1px solid #f0f0f0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 0;
          padding: 0 16px;
        }
        .knowledge-side-lable {
          height: 216px;
        }
        .search-history-body {
          padding: 8px 16px 24px;
          > div {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 16px 0;
            border-bottom: 1px dashed #f0f0f0;
            > p {
              margin-bottom: 0;
              width: 60%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 14px;
              color: #262626;
            }
            > span {
              color: #8c8c8c;
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}
</style>
<style>
.knowledge-list-head-search .ant-input-lg {
  font-size: 14px;
  border: 2px solid #1abc9c !important;
}
.knowledge-list-head-search .ant-btn-lg {
  font-size: 14px;
  background: #1abc9c !important;
  border-color: #1abc9c !important;
}
.wordCloud {
  height: 100% !important;
}
</style>
